angular.module('env.custom.customModule.filters', [])

    .filter('getPrescriptionFileNameId', function (attachmentsHelperService) {
        return function (dataItem) {
            return attachmentsHelperService.getPrescriptionFileNameId(dataItem);
        };
    })

    .filter('getLeftFootImageFileNameId', function (attachmentsHelperService) {
        return function (dataItem) {
            return attachmentsHelperService.getLeftFootImageFileNameId(dataItem);
        };
    })

    .filter('getRightFootImageFileNameId', function (attachmentsHelperService) {
        return function (dataItem) {
            return attachmentsHelperService.getRightFootImageFileNameId(dataItem);
        };
    })

    .filter('getLeftFootScanFileNameId', function (attachmentsHelperService) {
        return function (dataItem) {
            return attachmentsHelperService.getLeftFootScanFileNameId(dataItem);
        };
    })

    .filter('getRightFootScanFileNameId', function (attachmentsHelperService) {
        return function (dataItem) {
            return attachmentsHelperService.getRightFootScanFileNameId(dataItem);
        };
    })
;
